import { TIER_LABEL } from "../../lib/api";

const Stat = ({ label, value, testid }) => (
  <div className="border border-[#0E1B3D]/[0.08] bg-[#FFFFFF] p-6 sm:p-8">
    <p className="font-mono-x text-[0.65rem] tracking-[0.22em] uppercase text-[#4A5878]">{label}</p>
    <p data-testid={testid} className="mt-4 font-display text-4xl sm:text-5xl text-[#0E1B3D]">{value}</p>
  </div>
);

export function Overview({ stats }) {
  const s = stats || {};
  const by = s.by_tier || {};
  const total = Math.max(1, s.subscribers || 0);
  return (
    <div data-testid="admin-overview" className="space-y-6">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        <Stat label="Active subscribers" value={s.subscribers ?? 0} testid="admin-stats-subscribers" />
        <Stat label="Monthly revenue" value={`$${(s.mrr ?? 0).toLocaleString()}`} testid="admin-stats-mrr" />
        <Stat label="Tips received" value={`$${(s.tips_total ?? 0).toLocaleString()}`} testid="admin-stats-tips" />
        <Stat label="Pay-per-view sales" value={`$${(s.ppv_total ?? 0).toLocaleString()}`} testid="admin-stats-ppv" />
        <Stat label="Unread messages" value={s.unread_messages ?? 0} testid="admin-stats-unread" />
      </div>
      <div className="border border-[#0E1B3D]/[0.08] bg-[#FFFFFF] p-6 sm:p-8">
        <p className="font-mono-x text-[0.65rem] tracking-[0.22em] uppercase text-[#4A5878] mb-6">Tier distribution · {s.members ?? 0} registered members</p>
        <div className="space-y-5">
          {["fan", "vip", "inner"].map((t) => (
            <div key={t} data-testid={`admin-tier-bar-${t}`}>
              <div className="flex justify-between text-sm mb-2"><span className="text-[#0E1B3D]">{TIER_LABEL[t]}</span><span className="text-[#4A5878]">{by[t] ?? 0}</span></div>
              <div className="h-1.5 bg-[#0E1B3D]/[0.06]"><div className="h-full bg-[#D7263D] transition-[width] duration-700" style={{ width: `${((by[t] ?? 0) / total) * 100}%` }} /></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
